import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmAutomationScriptsApi } from './types';

export const emAutomationScripts: TEmAutomationScriptsApi = {
	getAvailableScripts: () =>
		http.get(endpoint.emAutomationScripts.GET_AVAILABLE_SCRIPTS).then(response => response.data),
	getAssignedScripts: payload =>
		http
			.post(endpoint.emAutomationScripts.GET_ASSIGNED_SCRIPTS(payload.emId), payload.body)
			.then(response => response.data),
	assignScript: payload => http.post(endpoint.emAutomationScripts.ASSIGN_SCRIPT, payload),
	removeScript: payload =>
		http.delete(endpoint.emAutomationScripts.REMOVE_SCRIPT(payload.id, payload.emId)),
};
